import { render, staticRenderFns } from "./MutiFactorForm.vue?vue&type=template&id=4ef13432&"
import script from "./MutiFactorForm.vue?vue&type=script&lang=js&"
export * from "./MutiFactorForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports